import { cn } from "@/lib/utils";
import { PAGE_STATUS_CONFIG } from "@/lib/status-configs";
import { FileText } from "@phosphor-icons/react";
import type { PageStatusFilter } from "./PageFilterTabs";

export function PageEmptyState({
  status,
  hasSearch,
}: {
  status: PageStatusFilter;
  hasSearch: boolean;
}) {
  const config = status
    ? PAGE_STATUS_CONFIG[status as keyof typeof PAGE_STATUS_CONFIG]
    : null;
  const Icon = config?.icon || FileText;

  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border/60 bg-muted/20 px-6 py-16 text-center">
      <div
        className={cn(
          "mb-4 flex size-16 items-center justify-center rounded-2xl",
          config?.bg || "bg-muted/40"
        )}
      >
        <Icon className={cn("size-7", config?.color || "text-muted-foreground")} />
      </div>
      <h3
        className="text-lg font-semibold text-foreground"
        style={{ fontFamily: "var(--font-heading)" }}
      >
        {hasSearch ? "Nema rezultata pretrage" : "Nema stranica"}
      </h3>
      <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">
        {hasSearch
          ? "Pokušajte s drugačijim pojmom za pretragu."
          : status === "published"
            ? "Još nema objavljenih stranica."
            : status === "draft"
              ? "Nema nacrta stranica."
              : "Kreirajte prvu stranicu klikom na \"Nova stranica\"."}
      </p>
    </div>
  );
}
